
import axios from "axios";
import moment from 'moment'
import { LIMITE_REGISTROS_PESQUISA } from '../../../static/parametros/parametros.js'

export default {
  namespaced: true,
  state: {
      lista: [],
      dt1: moment().format('YYYY-MM-DD'),
      dt2: moment().format('YYYY-MM-DD'),
      responsavelId : null,
      registroPosicao : null,
      registroId : null,
      registroSelecionadoId: null,
  },
  getters: {
    LISTA: state => {
        return state.lista
    },
    DT1: state => {
        return state.dt1
    },
    DT2: state => {
        return state.dt2
    },
    RESPONSAVEL_ID: state => {
        return state.responsavelId
    },
    REGISTRO_POSICAO: state => {
      for (let i = 0; i < state.lista.length; i++) {
        // Verificar se o objeto atual é igual ao objeto procurado
        if (state.lista[i].ID == state.registroId) {
          // Se forem iguais, retornar a posição do objeto
          state.registroPosicao = i
          return state.registroPosicao
        }
      }
      return state.registroPosicao
    },
    REGISTRO_ID: state => {
      return state.registroId
    },
    REGISTRO_SELECIONADO_ID: state => {
        return state.registroSelecionadoId
    }
  },
  /** MUTACOES SAO SINCRONAS - SEMELHANTES AO COMPUTED */
  mutations: {
      SET_LISTA: (state, payload) => {
          state.lista = payload
      },
      SET_DT1: (state, payload) => {
          state.dt1 = payload
      },
      SET_DT2: (state, payload) => {
          state.dt2 = payload
      },
      SET_RESPONSAVEL_ID: (state, payload) => {
        state.responsavelId = payload
      },
      SET_LIMPAR: (state, payload) => {
        state.lista = []
        state.dt1 = moment().format('YYYY-MM-DD')
        state.dt2 = moment().format('YYYY-MM-DD')
        state.responsavelId = null
        state.registroPosicao = null
      },
      SET_REGISTRO_POSICAO: (state, payload) => {
        state.registroPosicao = payload
      },
      SET_REGISTRO_ID: (state, payload) => {
        state.registroId = payload
      },
      SET_REGISTRO_SELECIONADO_ID: (state, payload) => {
          state.registroSelecionadoId = payload
      }
  },
  /** ACTOINS SAO ASSINCRONOS */
  actions: {
    GERAR_LISTA: async ({ commit, getters}, { skipConfirmation = false } = {}) => {
      let responsavelId = (getters.RESPONSAVEL_ID !== null ? getters.RESPONSAVEL_ID : '')
      let dt1 = (getters.DT1 !== null ? getters.DT1 : '')
      let dt2 = (getters.DT2 !== null ? getters.DT2 : '')
      let uri = `/api/protected/producao/resumo/pesquisar?dt1=${dt1}`+
                `&dt2=${dt2}`
      if (responsavelId) {
        uri += `&responsavelId=${responsavelId}`
      }
      
      const { data, status } = await axios.get(uri)
      
      // Verifica se o resultado tem mais de LIMITE_REGISTROS_PESQUISA registros e precisa de confirmação
      if (!skipConfirmation && data && data.length > LIMITE_REGISTROS_PESQUISA) {
        // Retorna os dados sem comitar, indicando que precisa de confirmação
        return { 
          data, 
          status,
          needsConfirmation: true,
          count: data.length
        }
      }
      
      // Carrega os dados normalmente
      commit("SET_LISTA", data)
      
      return { data, status, needsConfirmation: false }
    },
  }
}


// WEBPACK FOOTER //
// ./src/vuex/modulos/abate-resumo-store.js